var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWethIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 48 78",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-280.45,-105.811)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.0305815,0,0,0.0305815,280.947,106.311)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M767.266,0L750.51,56.954L750.51,1709.64L767.266,1726.37L1534.42,1272.9L767.266,0Z",
    style: {
      fill: "rgb(79,189,213)",
      fillRule: "nonzero",
      stroke: "rgb(79,189,213)",
      strokeWidth: "32.7px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M767.272,0L0.114,1272.9L767.272,1726.37L767.272,0Z",
    style: {
      fill: "rgb(165,212,223)",
      fillRule: "nonzero",
      stroke: "rgb(165,212,223)",
      strokeWidth: "32.7px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M767.266,1871.62L757.824,1883.13L757.824,2471.86L767.266,2499.44L1534.89,1418.39L767.266,1871.62Z",
    style: {
      fill: "rgb(79,189,213)",
      fillRule: "nonzero",
      stroke: "rgb(79,189,213)",
      strokeWidth: "32.7px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M767.272,2499.43L767.272,1871.61L0.114,1418.38L767.272,2499.43Z",
    style: {
      fill: "rgb(165,212,223)",
      fillRule: "nonzero",
      stroke: "rgb(165,212,223)",
      strokeWidth: "32.7px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M767.266,1726.37L1534.41,1272.91L767.266,924.215L767.266,1726.37Z",
    style: {
      fill: "rgb(51,57,68)",
      fillRule: "nonzero",
      stroke: "rgb(51,57,68)",
      strokeWidth: "32.7px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.114,1272.9L767.26,1726.37L767.26,924.209L0.114,1272.9Z",
    style: {
      fill: "rgb(74,113,156)",
      fillRule: "nonzero",
      stroke: "rgb(74,113,156)",
      strokeWidth: "32.7px"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWethIcon);
export default __webpack_public_path__ + "static/media/WETH_icon.bcd7333a0e4c7a59500942cf43e31bca.svg";
export { ForwardRef as ReactComponent };